import {
    Collapse,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    MenuItem,
    TextField,
    Link,
    Chip,
} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/styles";
import {ExpandLess, ExpandMore} from "@material-ui/icons";
import axios from 'axios';
import _ from 'lodash';
import qs from 'qs';
import {formatDateDMYHCommaSeparated} from "../../../../helpers/utils";
import {Autocomplete} from "@material-ui/lab";
import useEffectExceptOnMount from "../../../../helpers/useEffectExceptOnMount";

const useStyles = makeStyles((theme) => ({
    contentSection: {
        padding: '16px 22px',
        background: '#fff',
        marginBottom: '15px',
        borderRadius: '3px',
    },
    contentSectionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        cursor: 'pointer'
    },
    contentSectionHeaderTitle: {
        fontSize: '17px',
        fontWeight: '600',
        color: '#000',
    },
    formGroup: {
        padding: theme.spacing(2, 0)
    },
    tabActive: {
        color: '#1E69E5',
    },
    inheritFontWeight: {
        fontWeight: 'inherit',
    },
    fiftyPercentWidth: {
        width: '50%',
    },
}));

const InvestmentCommitteeMember = ({tab, handleTabChange, contactCrdId, adminUserSession, setHasUnsavedChanges}) => {
    const classes = useStyles();
    
    const [enableSave, setEnableSave] = useState(false);
    const [enableLanguagesSave, setEnableLanguagesSave] = useState(false);
    const [selected, setSelected] = useState(false);
    const [data, setData] = useState({id: 0, automatic: true, updated_at: null, is_member: false, confidence: null, reasoning: null})
    const [languagesData, setLanguagesData] = useState({automatic: true, updated_at: null, languages_ids: []})
    const [openLanguages, setOpenLanguages] = useState(false)
    const [languagesOptions, setLanguagesOptions] = useState([])
    const [languagesIds, setLanguagesIds] = useState([])
    const [dataProducingAdvisor, setDataProducingAdvisor] = useState({id: 0, automatic: true, updated_at: null, is_producing_advisor: false})
    const [selectedProducingAdvisor, setSelectedProducingAdvisor] = useState(false);
    const [enableSaveProducingAdvisor, setEnableSaveProducingAdvisor] = useState(false);

    useEffectExceptOnMount(() => {
        if (enableSave || enableLanguagesSave || enableSaveProducingAdvisor) {
            setHasUnsavedChanges(true)
        } else {
            setHasUnsavedChanges(false)
        }
    }, [enableSave, enableLanguagesSave, enableSaveProducingAdvisor])

    useEffect(() => {
        axios.get(
            `/v1/admin/ria_contacts/${contactCrdId}/investment_committee_member`,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'X-Admin-User-Email': adminUserSession.email,
                    'X-Admin-User-Token': adminUserSession.token
                }
            }
        ).then((response) => {
            const {
                is_member,
                automatic,
                updated_at,
                status,
                confidence,
                reasoning,
            } = response.data

            if (status === 'fetched') {
                setData({automatic:automatic, is_member:is_member, updated_at:updated_at, confidence:confidence ?? null, reasoning:reasoning ?? null})
                setSelected(is_member);
            }
        })
        axios.get(
            `/v1/admin/ria_contacts/${contactCrdId}/languages_spoken`,
            {
                headers: {
                    'X-Admin-User-Email': adminUserSession.email,
                    'X-Admin-User-Token': adminUserSession.token
                }
            }
        ).then((response) => {
            const {
                languages_ids,
                automatic,
                updated_at,
                status,
                languages_options,
            } = response.data

            if (status === 'fetched') {
                setLanguagesOptions(languages_options)
                setLanguagesData({automatic, updated_at, languages_ids})
                setLanguagesIds(languages_ids)
            }
        })
        axios.get(
          `/v1/admin/ria_contacts/${contactCrdId}/producing_advisors`,
          {
              headers: {
                  'Content-Type': 'multipart/form-data',
                  'X-Admin-User-Email': adminUserSession.email,
                  'X-Admin-User-Token': adminUserSession.token
              }
          }
        ).then((response) => {
            const {
                is_producing_advisor,
                confidence,
                reasoning,
                automatic,
                updated_at,
                status,
            } = response.data

            if (status === 'fetched') {
                setDataProducingAdvisor({automatic:automatic, is_producing_advisor:is_producing_advisor, updated_at:updated_at, confidence:confidence, reasoning:reasoning })
                setSelectedProducingAdvisor(is_producing_advisor);
            }
        })
    }, [])

    const handleUpdate = () => {
        axios.put(
            `/v1/admin/ria_contacts/${contactCrdId}/update_investment_committee_member`,
            qs.stringify({is_member: selected}),
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'X-Admin-User-Email': adminUserSession.email,
                    'X-Admin-User-Token': adminUserSession.token
                }
            }
        ).then((response) => {
            const {
                is_member,
                confidence,
                reasoning,
                automatic,
                updated_at,
                status,
            } = response.data

            if (status === 'fetched') {
                setData({automatic: automatic, is_member: is_member, updated_at: updated_at, confidence: confidence ?? null, reasoning: reasoning ?? null});
                setSelected(is_member);
            }
            setEnableSave(false);
        })
    }

    const handleUpdateLanguages = () => {
        axios.put(
            `/v1/admin/ria_contacts/${contactCrdId}/update_languages_spoken`,
            {languages_ids: languagesIds},
            {
                headers: {
                    'X-Admin-User-Email': adminUserSession.email,
                    'X-Admin-User-Token': adminUserSession.token
                }
            }
        ).then((response) => {
            const {
                ria_contact_language,
                status,
            } = response.data

            setLanguagesData(ria_contact_language);
            setLanguagesIds(ria_contact_language.languages_ids)
            setEnableLanguagesSave(false);
        })
    }

    const handleUpdateProducingAdvisor = () => {
        axios.put(
          `/v1/admin/ria_contacts/${contactCrdId}/update_producing_advisors`,
          qs.stringify({is_producing_advisor: selectedProducingAdvisor}),
          {
              headers: {
                  'Content-Type': 'multipart/form-data',
                  'X-Admin-User-Email': adminUserSession.email,
                  'X-Admin-User-Token': adminUserSession.token
              }
          }
        ).then((response) => {
            const {
                is_producing_advisor,
                confidence,
                reasoning,
                automatic,
                updated_at,
                status,
            } = response.data

            if (status === 'fetched') {
                setDataProducingAdvisor({automatic:automatic, is_producing_advisor:is_producing_advisor, updated_at:updated_at, confidence:confidence, reasoning:reasoning })
                setSelectedProducingAdvisor(is_producing_advisor);
            }
            setEnableSaveProducingAdvisor(false);
        })
    }

    const handleOnChange = (value) => {
        const updatedValue = value === 'Yes'
        setSelected(updatedValue);

        if (!_.isEqual(data.is_member, updatedValue)) {
            setEnableSave(true);
        } else {
            setEnableSave(false);
        }
    }

    const handleOnChangeProducingAdvisor = (value) => {
        const updatedValue = value === 'Yes'
        setSelectedProducingAdvisor(updatedValue);

        if (!_.isEqual(dataProducingAdvisor.is_producing_advisor, updatedValue)) {
            setEnableSaveProducingAdvisor(true);
        } else {
            setEnableSaveProducingAdvisor(false);
        }
    }

    const handleReset = () => {
        setSelected(data.is_member);
        setEnableSave(false);
    }

    const handleResetLanguages = () => {
        setLanguagesIds(languagesData.languages_ids)
        setEnableLanguagesSave(false);
    }

    const handleResetProducingAdvisor = () => {
        setSelectedProducingAdvisor(dataProducingAdvisor.is_producing_advisor);
        setEnableSaveProducingAdvisor(false);
    }

    const handleOnChangeAutocomplete = (selectedValue) => {
        setLanguagesIds(selectedValue.map((values) => values.id))
        setEnableLanguagesSave(true)
    }

    return (
        <div className={classes.contentSection}>
            <div className={classes.contentSectionHeader}
                 onClick={(event) => handleTabChange(event, 'investmentCommitteeMember')}>
                <Typography variant='h5'
                            className={`${classes.contentSectionHeaderTitle}
                            ${tab === 'investmentCommitteeMember' ? classes.tabActive : ''}`}>
                    FINTRX Native Data
                </Typography>
                {tab === 'investmentCommitteeMember' ? <ExpandLess/> : <ExpandMore/>}
            </div>
            <Collapse in={tab === 'investmentCommitteeMember'}>
                <div className={classes.contentSectionContent}>
                    <div className={classes.formGroup}>
                        <TableContainer className='table-container'>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.inheritFontWeight}>Is Investment Committee Member</TableCell>
                                        <TableCell className={classes.inheritFontWeight}>Confidence</TableCell>
                                        <TableCell className={classes.inheritFontWeight}>Reasoning</TableCell>
                                        <TableCell className={classes.inheritFontWeight}>Automatic</TableCell>
                                        <TableCell className={classes.inheritFontWeight}>Date Updated</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow hover>
                                        <TableCell className={classes.inheritFontWeight}>
                                            <TextField
                                                select
                                                fullWidth
                                                value={selected ? 'Yes' : 'No'}
                                                name=''
                                                label=''
                                                variant='outlined'
                                                onChange={(e) => handleOnChange(e.target.value)}
                                            >
                                                <MenuItem value='Yes'>Yes</MenuItem>
                                                <MenuItem value='No'>No</MenuItem>
                                            </TextField>
                                        </TableCell>
                                        <TableCell className={classes.inheritFontWeight}>{data?.confidence ?? '-'}</TableCell>
                                        <TableCell className={classes.inheritFontWeight}>{data?.reasoning ?? '-'}</TableCell>
                                        <TableCell className={classes.inheritFontWeight}>{data && !data.automatic ? 'Manual' : 'Auto'}</TableCell>
                                        <TableCell className={classes.inheritFontWeight}>{data.updated_at ? formatDateDMYHCommaSeparated(data.updated_at) : '-'}</TableCell>
                                        <TableCell className={classes.inheritFontWeight}>
                                            {
                                                enableSave ?
                                                    <React.Fragment>
                                                        <div style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
                                                            <Link onClick={handleUpdate}>
                                                                Save
                                                            </Link>
                                                            |
                                                            <Link onClick={handleReset}>
                                                                Cancel
                                                            </Link>
                                                        </div>
                                                    </React.Fragment>
                                                    : null
                                            }
                                        </TableCell>
                                    </TableRow>

                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TableContainer className='table-container'>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.inheritFontWeight}>Languages Spoken</TableCell>
                                        <TableCell className={classes.inheritFontWeight}>Auto/Manual</TableCell>
                                        <TableCell className={classes.inheritFontWeight}>Date Updated</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow hover>
                                        <TableCell className={classes.inheritFontWeight}>
                                            <Autocomplete
                                                multiple
                                                id="languages_ids"
                                                open={openLanguages}
                                                onOpen={() => setOpenLanguages(true)}
                                                onClose={() => setOpenLanguages(false)}
                                                onChange={(_e, value) => handleOnChangeAutocomplete(value)}
                                                getOptionSelected={(option, value) => option.id === value.id}
                                                getOptionLabel={(option) => option.name}
                                                options={languagesOptions}
                                                value={languagesIds ? languagesOptions.filter(l => languagesIds.includes(l.id)) : []}
                                                renderTags={(value, getTagProps) =>
                                                    value.map((option, index) => (
                                                        <Chip classes={{ root: classes.chipRoot, label: classes.chipLabel, deleteIcon: classes.whiteIcon }} label={option.name} {...getTagProps({ index })} />
                                                    ))
                                                }
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Languages Spoken"
                                                        variant="outlined"
                                                        className={classes.field}
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <React.Fragment>
                                                                    {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                            ),
                                                        }}
                                                    />
                                                )}
                                            />
                                        </TableCell>
                                        <TableCell
                                            className={classes.inheritFontWeight}>{languagesData && !languagesData.automatic ? 'Manual' : 'Auto'}</TableCell>
                                        <TableCell
                                            className={classes.inheritFontWeight}>{languagesData.updated_at ? formatDateDMYHCommaSeparated(languagesData.updated_at) : '-'}</TableCell>
                                        <TableCell className={classes.inheritFontWeight}>
                                            {
                                                enableLanguagesSave ?
                                                    <React.Fragment>
                                                        <div style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
                                                            <Link onClick={handleUpdateLanguages}>
                                                                Save
                                                            </Link>
                                                            |
                                                            <Link onClick={handleResetLanguages}>
                                                                Cancel
                                                            </Link>
                                                        </div>
                                                    </React.Fragment>
                                                    : null
                                            }
                                        </TableCell>
                                    </TableRow>

                                </TableBody>
                            </Table>
                        </TableContainer>

                        <TableContainer className='table-container'>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.inheritFontWeight}>Is Producing Advisors</TableCell>
                                        <TableCell className={classes.inheritFontWeight}>Confidence</TableCell>
                                        <TableCell className={classes.inheritFontWeight}>Reasoning</TableCell>
                                        <TableCell className={classes.inheritFontWeight}>Automatic</TableCell>
                                        <TableCell className={classes.inheritFontWeight}>Date Updated</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow hover>
                                        <TableCell className={classes.inheritFontWeight}>
                                            <TextField
                                              select
                                              fullWidth
                                              value={selectedProducingAdvisor ? 'Yes' : 'No'}
                                              name=''
                                              label=''
                                              variant='outlined'
                                              // onChange={handleFieldChange}
                                              onChange={(e) => handleOnChangeProducingAdvisor(e.target.value)}
                                            >
                                                <MenuItem value='Yes'>Yes</MenuItem>
                                                <MenuItem value='No'>No</MenuItem>
                                            </TextField>
                                        </TableCell>
                                        <TableCell className={classes.inheritFontWeight}>{dataProducingAdvisor?.confidence ?? '-'}</TableCell>
                                        <TableCell className={classes.inheritFontWeight}>{dataProducingAdvisor?.reasoning ?? '-'}</TableCell>
                                        <TableCell className={classes.inheritFontWeight}>{dataProducingAdvisor && !dataProducingAdvisor.automatic ? 'Manual' : 'Auto'}</TableCell>
                                        <TableCell className={classes.inheritFontWeight}>{dataProducingAdvisor.updated_at ? formatDateDMYHCommaSeparated(dataProducingAdvisor.updated_at) : '-'}</TableCell>
                                        <TableCell className={classes.inheritFontWeight}>
                                            {
                                                enableSaveProducingAdvisor ?
                                                  <React.Fragment>
                                                      <div style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
                                                          <Link onClick={handleUpdateProducingAdvisor}>
                                                              Save
                                                          </Link>
                                                          |
                                                          <Link onClick={handleResetProducingAdvisor}>
                                                              Cancel
                                                          </Link>
                                                      </div>
                                                  </React.Fragment>
                                                  : null
                                            }
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </Collapse>
        </div>
    )
}

export default InvestmentCommitteeMember;